import { SelectedFilters } from '@lidea/shared/data-access/core';
import { Filters, FiltersOptions } from '@lidea/shared/util/types';

import { Filter } from './filter/filter';
import styles from './search-filters.module.css';

export interface SearchFiltersProps {
  filters: FiltersOptions;
  selectedFilters: SelectedFilters;
  onFilterClick: (filter: keyof Filters) => void;
}

export function SearchFilters(props: SearchFiltersProps) {
  return (
    <div className={styles.grid}>
      {Object.values(props.filters).map((filter) => (
        <Filter
          key={filter.value}
          {...filter}
          selected={props.selectedFilters[filter.value]?.length || 0}
          onClick={() => props.onFilterClick(filter.value)}
        />
      ))}
    </div>
  );
}

export default SearchFilters;
